import { RefObject, useEffect } from 'react';

import { getKeyboardInset } from '../get-keyboard-inset/get-keyboard-inset';
import { scheduleScrollFocusedInputIntoView } from '../scroll-focused-input-into-view/scroll-focused-input-into-view';

const KEYBOARD_INSET_EXTRA = 32;

export function useKeyboardInset(
  elementRef: RefObject<HTMLElement | null>,
  enabled = false
) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const element = elementRef.current;
    const viewport = window.visualViewport;

    if (!element || !viewport) {
      return;
    }

    const update = () => {
      element.style.setProperty(
        '--keyboard-inset',
        `${getKeyboardInset() + KEYBOARD_INSET_EXTRA}px`
      );
      scheduleScrollFocusedInputIntoView();
    };

    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);

    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      element.style.removeProperty('--keyboard-inset');
    };
  }, [enabled, elementRef]);
}
